// extracted by mini-css-extract-plugin
export default {"changeLink":"wK-z","disabled":"xK-z","inline":"yK-z"};